/**
 * Ban Type Enums for Debt Payment
 * Defines the 7 different ban states and their groupings
 */

export const BanTypeEnum = {
  BAN_WITH_DEBT: 1,
  BAN_WITHOUT_PAYMENT_METHOD: 2,
  BAN_WITH_FUTURE_INVOICE: 3,
  BAN_WITH_BALANCE_FOR_CHARGING: 4,
  BAN_NO_DEBT_NO_PREVIOUS_DEBT: 5,
  BAN_NO_DEBT_BUT_HAD_DEBT_IN_INVOICE: 6,
  BAN_WITH_DEBT_ABOVE_MAX: 7,
};

/**
 * Ban Group Enums
 * Group A: Bans with financial issues
 * Group B: Bans without financial issues
 */
export const BanGroupEnum = {
  /** Group A: Accounts with financial issues (Types: 1, 2, 6, 7) */
  FINANCIAL_ISSUES: 'FINANCIAL_ISSUES',

  /** Group B: Accounts without financial issues (Types: 3, 4, 5) */
  NO_FINANCIAL_ISSUES: 'NO_FINANCIAL_ISSUES',
};

/**
 * Maps ban types to their respective groups
 */
export const BanTypeToGroupMap = {
  [BanTypeEnum.BAN_WITH_DEBT]: BanGroupEnum.FINANCIAL_ISSUES,
  [BanTypeEnum.BAN_WITH_DEBT_ABOVE_MAX]: BanGroupEnum.FINANCIAL_ISSUES,
  [BanTypeEnum.BAN_WITHOUT_PAYMENT_METHOD]: BanGroupEnum.FINANCIAL_ISSUES,
  [BanTypeEnum.BAN_NO_DEBT_BUT_HAD_DEBT_IN_INVOICE]: BanGroupEnum.FINANCIAL_ISSUES,
  [BanTypeEnum.BAN_WITH_FUTURE_INVOICE]: BanGroupEnum.NO_FINANCIAL_ISSUES,
  [BanTypeEnum.BAN_WITH_BALANCE_FOR_CHARGING]: BanGroupEnum.NO_FINANCIAL_ISSUES,
  [BanTypeEnum.BAN_NO_DEBT_NO_PREVIOUS_DEBT]: BanGroupEnum.NO_FINANCIAL_ISSUES,
};

/**
 * Display order within groups (lower number = higher priority)
 * Group A order: Type 1, Type 7, Type 2, Type 6
 * Group B order: Type 3, Type 4, Type 5
 */
export const BanTypeDisplayOrder = {
  [BanTypeEnum.BAN_WITH_DEBT]: 1,
  [BanTypeEnum.BAN_WITH_DEBT_ABOVE_MAX]: 2,
  [BanTypeEnum.BAN_WITHOUT_PAYMENT_METHOD]: 3,
  [BanTypeEnum.BAN_NO_DEBT_BUT_HAD_DEBT_IN_INVOICE]: 4,
  [BanTypeEnum.BAN_WITH_FUTURE_INVOICE]: 5,
  [BanTypeEnum.BAN_WITH_BALANCE_FOR_CHARGING]: 6,
  [BanTypeEnum.BAN_NO_DEBT_NO_PREVIOUS_DEBT]: 7,
};

/**
 * Ban type names (Hebrew)
 */
export const BanTypeDisplayNames = {
  [BanTypeEnum.BAN_WITH_DEBT]: 'לקוח עם חוב',
  [BanTypeEnum.BAN_WITHOUT_PAYMENT_METHOD]: 'לקוח ללא אמצעי תשלום',
  [BanTypeEnum.BAN_WITH_FUTURE_INVOICE]: 'לקוח עם חשבונית עתידית לחיוב',
  [BanTypeEnum.BAN_WITH_BALANCE_FOR_CHARGING]: 'לקוח עם יתרה לחיוב',
  [BanTypeEnum.BAN_NO_DEBT_NO_PREVIOUS_DEBT]: 'לקוח ללא חוב או יתרה',
  [BanTypeEnum.BAN_NO_DEBT_BUT_HAD_DEBT_IN_INVOICE]: 'לקוח ללא חוב אך היה חוב בחיוב',
  [BanTypeEnum.BAN_WITH_DEBT_ABOVE_MAX]: 'לקוח עם חוב מעל תקרה',
};

// Hebrew month names
export const hebrewMonths = ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'];
